import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { usePortfolioVersion } from './portfolio';

export function useApi<T>(path: string | null, initial?: T) {
  const portfolioVersion = usePortfolioVersion();
  const [data, setData] = useState<T | undefined>(initial);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    setError(null);
    try {
      setData(await api<T>(path));
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'The data could not be loaded.');
    } finally {
      setLoading(false);
    }
  }, [path, portfolioVersion]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { data, setData, loading, error, refresh };
}
